import React from 'react'
import { FormikInputLabel } from '@pga/pga-component-library'
import { StyledButton, StyledInputField, FormContainer } from '../../shared.styles'

const ProxyRequestForm = ({ formData, handleChange, handleSubmit }) => {
  const {
    memberEmail, proxyFirstName, proxyLastName, proxyEmail, confirmProxyEmail
  } = formData

  return (
    <FormContainer>
      <h3>Proxy Information</h3>
      <FormikInputLabel field='memberEmail'>Your Email Address</FormikInputLabel>
      <StyledInputField id='memberEmail' value={memberEmail} onChange={handleChange('memberEmail')} />
      <FormikInputLabel field='proxyFirstName'>Proxy First Name</FormikInputLabel>
      <StyledInputField id='proxyFirstName' value={proxyFirstName} onChange={handleChange('proxyFirstName')} />
      <FormikInputLabel field='proxyLastName'>Proxy Last Name</FormikInputLabel>
      <StyledInputField id='proxyLastName' value={proxyLastName} onChange={handleChange('proxyLastName')} />
      <FormikInputLabel field='proxyEmail'>Proxy Email Address</FormikInputLabel>
      <StyledInputField id='proxyEmail' value={proxyEmail} onChange={handleChange('proxyEmail')} />
      <FormikInputLabel field='confirmProxyEmail'>Confirm Proxy Email Address</FormikInputLabel>
      <StyledInputField id='confirmProxyEmail' value={confirmProxyEmail} onChange={handleChange('confirmProxyEmail')} />
      <StyledButton onClick={handleSubmit}>Submit</StyledButton>
    </FormContainer>
  )
}

export default ProxyRequestForm
